
// Libraries
var React = require('react');

// Styles
require('./LoadMore.scss');

class LoadMore extends React.Component {
	render() {
		const buttonLabel = `${this.props.caption} ${this.props.context}`;

		return (
			<div className="LoadMore" >
				{this.props.caption !== null &&
					<button onClick={this.props.handle}  aria-label={buttonLabel} className="c-button c-button--outline c-button--small c-button--dark">{this.props.caption}</button>
				}
			</div>
		)
	}
}

module.exports = LoadMore;



// WEBPACK FOOTER //
// ./src/common/LoadMore/LoadMore.js